module.exports = __webpack_public_path__ + "img/ZH_M.a66930aa.png";